import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import i18n from './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialisation Sentry (si DSN configuré)
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    environment: process.env.NODE_ENV,
    initialScope: { tags: { platform: 'pwa-product-nutriscore' } },
  });
}
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC7Jxsx9YQBPMF4cBqoKJqQBS8zgyGm9Ow",
  authDomain: "nutriscore-b6448.firebaseapp.com",
  projectId: "nutriscore-b6448",
  storageBucket: "nutriscore-b6448.firebasestorage.app",
  messagingSenderId: "305632527500",
  appId: "1:305632527500:web:9fcbd7757c649c6cdbe7a9",
  measurementId: "G-J54XW50KEF"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Une erreur est survenue. Veuillez rafraîchir la page.</div>}>
      <BrowserRouter>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Enregistrer le Service Worker pour permettre l'installation en PWA
// Ne pas reporter les échecs à Sentry : attendus avec bots (Google-Read-Aloud), WebViews, etc.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/sw.js`)
      .then(() => Sentry.addBreadcrumb({ category: 'pwa', message: 'Service Worker enregistré' }))
      .catch((err) => {
        Sentry.addBreadcrumb({ category: 'pwa', message: 'Service Worker non enregistré', level: 'info', data: { error: String(err?.message || err) } });
        if (process.env.NODE_ENV === 'development') console.warn('Service Worker registration failed:', err);
      });
  });
}
